<template>
  <TemplateView>
    <div class="container">
      <TemplatePageGrid :items="workTypeGrid" :page-data="pageData" :loading="loadingAnimation">
        <template v-slot:buttons>
          <WorkTypeModal
            v-if="
              $userCheckAccess({
                abilities: 'edit_work_type',
              })
            "
            :create="true"
          />
        </template>
        <WorkTypeTable :workTypeGrid="workTypeGrid" />
      </TemplatePageGrid>
    </div>
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import TemplatePageGrid from 'components/templates/TemplatePageGrid'
import WorkTypeTable from 'components/setting/workType/WorkTypeTable'
import WorkTypeModal from 'components/setting/workType/WorkTypeModal'

export default {
  name: 'SettingWorkTypes',
  components: {
    TemplateView,
    TemplatePageGrid,
    WorkTypeTable,
    WorkTypeModal,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  computed: {
    ...mapGetters('workType', ['workTypeGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  methods: {
    ...mapActions('workType', ['onWorkTypeGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.limit,
        page: this.$route.query.page,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkTypeGrid(data)
    },
  },
}
</script>
